import {Injectable} from '@angular/core';
import { ɵNullViewportScroller } from '@angular/common';

declare global {
    interface Window {
        google: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoogleMapLoaderService {
    URL = 'https://maps.googleapis.com/maps/api/js';
    KEY = null;
    CLIENT = null;
    SENSOR = false;
    VERSION = '3.14';
    LIBRARIES = null;
    WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
    script = null;
    google = null;
    loading = false;
    callbacks = [];
    onLoadEvents = [];

    constructor() {}

    public load() {
        let url = this.URL;
        if (this.SENSOR === true) {
        url += '?sensor=true';
        } else {
        url += '?sensor=false';
        }
        if (this.KEY != null) {
        url += '&key=' + this.KEY;
        }
        if (this.CLIENT != null) {
        url += '&client=' + this.CLIENT + '&v=' + this.VERSION;
        }
        if (this.LIBRARIES != null) {
        url += '&libraries=' + this.LIBRARIES;
        }
        url += '&callback=' + this.WINDOW_CALLBACK_NAME;
        // console.log('******** google-map-loader.ts, window.google = ' + window.google);
        this.google = window.google;
        const scriptLoadingPromise = new Promise<void>((resolve, reject) => {
            if (this.google == null) {
                this.script = document.createElement('script');
                this.script.type = 'text/javascript';
                this.script.src = url;

                document.body.appendChild(this.script);

                (window)[this.WINDOW_CALLBACK_NAME] = () => {
                    this.google = window.google;
                    resolve(this.google);
                };
                this.script.onerror = (error: Event) => { reject(error); };
            } else {
                resolve(this.google);
            }
        });
        return scriptLoadingPromise;
    }

    public load_OLD() {
        return new Promise((resolve) => {
            if (this.google === null) {
                if (this.loading === true) {
                  resolve(this.google);
                } else {
                  this.loading = true;
                  window[this.WINDOW_CALLBACK_NAME] = (function(self) {
                    return function() {
                        self.google = null;
                        self.loading = false;
                        self.callbacks = [];
                        self.onLoadEvents = [];
                        if (typeof window.google !== 'undefined') {
                          delete window.google;
                        }
                        if (typeof window[self.WINDOW_CALLBACK_NAME] !== 'undefined') {
                          delete window[self.WINDOW_CALLBACK_NAME];
                        }
                        if (self.script !== null) {
                            self.script.parentElement.removeChild(self.script);
                            self.script = null;
                        }
                    };
                  })(this);
                  let url = this.URL;
                  if (this.SENSOR === true) {
                    url += '?sensor=true';
                  } else {
                    url += '?sensor=false';
                  }
                  if (this.KEY != null) {
                    url += '&key=' + this.KEY;
                  }
                  if (this.CLIENT != null) {
                    url += '&client=' + this.CLIENT + '&v=' + this.VERSION;
                  }
                  if (this.LIBRARIES != null) {
                    url += '&libraries=' + this.LIBRARIES;
                  }
                  url += '&callback=' + this.WINDOW_CALLBACK_NAME;
                  this.script = document.createElement('script');
                  this.script.type = 'text/javascript';
                  this.script.src = url;
                  this.script.onload = () => {
                    resolve(window.google);
                  };
                  document.body.appendChild(this.script);
                }
            } else {
                resolve(this.google);
            }
        });
    }
}
